import apiClient from '../api/api';
import { API_ENDPOINTS } from '../api/api.config';

export interface OnedriveFile {
  id: string;
  name: string;
  mimeType: string; // "folder", "file", or actual MIME type like "image/png"
  children?: OnedriveFile[]; // Recursive children
}

// ✅ The API returns a single root node instead of { tree, summary }
export interface OnedriveListData {
  id: string;
  name: string;
  mimeType: string;
  children: OnedriveFile[];
}

export interface OnedriveListResponse {
  success: boolean;
  code: number;
  data: OnedriveListData;
}

export interface OnedriveUploadFolderRequest {
  access_token: string;
  folder_id: string;
  ai_performance_level: string;
  file_processing_type: string;
  documentStore_id: string;
}

export interface OnedriveUploadFolderResponse {
  success: boolean;
  code: number;
  message?: string;
}

class DropboxService {
  // GET: Initiate Dropbox authorization
  async authorize() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.ONEDRIVE.AUTH);
      return response;
    } catch (error) {
      console.error('Error authorizing Dropbox:', error);
      throw error;
    }
  }

  // POST: List files from Dropbox
  async listFiles(accessToken: string): Promise<OnedriveListResponse> {
    try {
      const response = await apiClient.post(
        API_ENDPOINTS.ONEDRIVE.LIST_FILES,
        { access_token: accessToken }
      );
      return response.data;
    } catch (error) {
      console.error('Error listing Dropbox files:', error);
      throw error;
    }
  }

  // PUT: Upload folder from Dropbox with processing
  async uploadFolder(data: any): Promise<OnedriveUploadFolderResponse> {
    try {
      const response = await apiClient.put(
        API_ENDPOINTS.ONEDRIVE.UPLOAD_FOLDER,
        data
      );
      return response.data;
    } catch (error) {
      console.error('Error uploading Dropbox folder:', error);
      throw error;
    }
  }

  // LocalStorage helpers
  static saveToken(token: string) {
    localStorage.setItem('dropbox_token', token);
  }

  static getToken(): string | null {
    return localStorage.getItem('dropbox_token');
  }

  static removeToken() {
    localStorage.removeItem('dropbox_token');
  }
}

export const dropboxService = new DropboxService();
export default dropboxService;
